import { httpClient } from "@services/api/httpClient";

interface GetOverviewParams {
  ids: string;
}

export async function getOfferMetrics({ ids }: GetOverviewParams) {
  const response = await httpClient.get("/offer/metrics", {
    params: { ids }
  });
  return response.data;
}